<script>
export default {
  inject: ['fieldsStatus'],
  data: ()=>({
    label: undefined
  }),
  mounted(){
    if (this.$el.classList.contains('aoformlabel'))
      this.label = this.$el
    else
      this.label = this.$el.querySelector('.aoformlabel')
  },
  watch:{
    modelValue(val){
      if (!this.label) return
      if (val)
        this.label.classList.add('filled')
      else
        this.label.classList.remove('filled')
    } 
  }
}
</script>

<style lang="sass">
.aoformfield
  display: block
  width: 100%
  border: none
  letter-spacing: globalvars.$onespacing
  border-bottom: 1px solid #DEE3EE
  transition: border-color .3s ease-out
  font-size: 16px
  line-height: 26px
  color: colors.$brownfont
  outline: none
  &:focus, &:focus-visible
    border-bottom: 2px solid colors.$bluefont5b
    margin-bottom: -1px
  &[disabled]
    pointer-events: none
  &_pointer
    cursor: pointer
  &_witharrow
    display: flex
    justify-content: space-between
    align-items: center
    svg
      min-width: 10px
      margin: 10px
      margin-right: 8px
      margin-left: 15px
      cursor: pointer
.aoformlabel__error:not(:empty)~.aoformfield:not(:focus)
  border-bottom: 2px solid colors.$newred !important
  margin-bottom: -1px
</style>